export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14566.b867ed52.jpg";